import { render, staticRenderFns } from "./ClvrPrscPosologyCustomized.vue?vue&type=template&id=45781a7d"
import script from "./ClvrPrscPosologyCustomized.ts?vue&type=script&lang=ts&external"
export * from "./ClvrPrscPosologyCustomized.ts?vue&type=script&lang=ts&external"
import style0 from "./ClvrPrscPosologyCustomized.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports